export const cifCm = ["301 201","<g fill-rule='nonzero' fill='none'><path fill='#007A5E' d='M.5.5h100v200H.5z'/><path fill='#CE1126' d='M100.5.5h100v200h-100z'/><path fill='#FCD116' d='M200.5.5h100v200h-100zM125.138 92.26l15.675 11.388-5.987 18.426 15.674-11.388 15.674 11.388-5.987-18.426 15.675-11.388H156.4l-5.9-18.427-5.899 18.427z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-cm.js
// module id = null
// module chunks = 